import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ModuleEventAttendancesStateModel extends PaginatedSubentityStateModel {
    static identifier = 'ModuleEventAttendancesStateModel';

    constructor() {
        super(ModuleEventAttendancesStateModel.identifier);
    }
}
